import {handleActions} from 'redux-actions';
import {NOTIFICATION_SET, NOTIFICATION_CLOSE} from './NotificationActions';

export const initialState = {
    type: 'success',
    text: '',
    isVisible: false,
};

export const setNotification = (state: any, {payload}:any) => {
    const {type, text, manualHide} = payload;
    const isVisible = true;
    
    if (type && text) {
        return {
            isVisible,
            type,
            text,
            manualHide,
        };
    }
    
    return state;
};

export const closeNotification = (state: any) => {
    return {
        ...state,
        isVisible: false,
    };
};

const handlers = {
    [NOTIFICATION_SET]: setNotification,
    [NOTIFICATION_CLOSE]: closeNotification,
};

export default handleActions(handlers, initialState);
